import { useTranslation } from 'react-i18next';
import SectionWrapper from '@/components/atoms/SectionWrapper';
import LogsTable from '@/components/AdminLogs/LogsTable';

export default function LogsConfigs() {
  const { t } = useTranslation();

  return (
    <SectionWrapper
      title={t('configLogs.title', 'Configurations Audit logs')}
      desc={t('configLogs.desc', 'Add, edit, or remove subscription plans.')}
    >
      <div className="space-y-6">
        <LogsTable />
      </div>
    </SectionWrapper>
  );
}
